export type McsLevel = 'acc' | 'pcc' | 'mcc';
export type McsStatus = 'done' | 'todo' | 'needs_attention' | 'not_applicable';
export interface EducationEntry { id: string; title: string; provider: string; hours: number; synchronous: boolean; is_icf_evaluation_training: boolean; completed_on: string | null; evidence_note: string }
export interface EvaluationTraining { level: McsLevel; course: string; completed_on: string | null; evidence_note: string }
export interface ExperienceEntry { id: string; kind: 'credentialed_client' | 'program_student'; label: string; credential_earned_on: string | null; note: string }
export interface Reflection { id: string; text: string; created_at: string }
export interface McsPrepInput {
  route: 'standard' | 'prior_learning' | null;
  target_levels: McsLevel[];
  credential_type: McsLevel | null;
  credential_status: 'active' | 'renewed' | 'lapsed' | null;
  acc_renewed: boolean;
  education_entries: EducationEntry[];
  evaluation_trainings: EvaluationTraining[];
  experience_entries: ExperienceEntry[];
  provider_letter_available: boolean;
  reflections: Reflection[];
}
export interface McsChecklistItem { key: string; level: McsLevel | null; status: McsStatus; detail: string; official_url: string }
export interface McsPrep extends McsPrepInput {
  checklist: {
    route: McsPrepInput['route']; target_levels: McsLevel[];
    eligibility: Pick<McsPrepInput, 'credential_type' | 'credential_status' | 'acc_renewed'> & { eligible: boolean };
    items: McsChecklistItem[];
    hours_summary: { total: number; synchronous: number; asynchronous: number; evaluation_training_hours: number; counted_for_route: number };
    notes: { key: string; text: string }[]; disclaimer_key: 'mcs.disclaimer';
  };
}
export interface McsCohortSummary { cohort_id: number; members: { user_id: number; display_name: string; route: McsPrepInput['route']; target_levels: McsLevel[]; checklist_counts: { done: number; todo: number; needs_attention: number }; has_provider_letter: boolean }[] }
// Explicit allowlist: response metadata and checklist must never reach PUT.
export function prepInput(record: McsPrepInput): McsPrepInput {
  const { route, target_levels, credential_type, credential_status, acc_renewed, education_entries, evaluation_trainings, experience_entries, provider_letter_available, reflections } = record;
  return { route, target_levels, credential_type, credential_status, acc_renewed, education_entries, evaluation_trainings, experience_entries, provider_letter_available, reflections };
}
